import { Link } from 'react-router-dom';
import { ArrowLeft, PenSquare } from 'lucide-react';

/**
 * Frame for the blog module inside the Control Tower cockpit. Provides the
 * tower-styled header (back to cockpit) and toast host, then renders the
 * shared BlogList / BlogEditor (basePath="/blog").
 */
export function TowerBlogSection({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-sunken text-fg">
      <header className="sticky top-0 z-50 border-b border-danger/20 bg-scrim/50 backdrop-blur-sm">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6">
          <div className="flex items-center gap-3">
            <div className="rounded-lg border border-danger/20 bg-danger/10 p-2">
              <PenSquare className="h-5 w-5 text-danger" />
            </div>
            <div>
              <h1 className="text-lg font-bold uppercase tracking-widest text-danger">
                Content · Blog
              </h1>
              <p className="text-[10px] uppercase tracking-[0.3em] text-danger/40">
                Marketing site publishing
              </p>
            </div>
          </div>
          <Link
            to="/"
            className="flex items-center gap-2 rounded border border-danger/20 px-4 py-2 text-xs uppercase tracking-widest text-danger transition-colors hover:bg-danger/10"
          >
            <ArrowLeft className="h-3 w-3" />
            Cockpit
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6">{children}</main>
    </div>
  );
}
